/**
 * En qué parte del programa estamos, para lo que se guarda en el navegador.
 *
 * La gestión del club, el portal del socio y el panel de plataforma viven en la
 * misma dirección y se reparten por la ruta, así que comparten el
 * almacenamiento del navegador. Lo que guarda cada uno lleva su prefijo: en la
 * tablet del mostrador conviven la gestión del club en catalán y el portal de
 * un socio holandés, y ni la sesión ni el idioma son la misma cosa.
 *
 * Vive aquí y no en api.ts porque no es cosa de las llamadas al servidor sino
 * de lo que se guarda en el aparato, y lo usan los dos.
 */

export type Ambito = "gestion" | "portal" | "plataforma";

let prefijo = "clubs.";

export function establecerAmbito(ambito: Ambito): void {
  prefijo =
    ambito === "portal"
      ? "clubs.portal."
      : ambito === "plataforma"
        ? "clubs.plataforma."
        : "clubs.";
}

/** «clubs.portal.token»: el nombre con el prefijo del ámbito de ahora. */
export function claveDelAmbito(nombre: string): string {
  return prefijo + nombre;
}
